module.exports = __webpack_public_path__ + "static/media/mobileMenu2.aa61f26a.jpeg";